import { Text } from '@actual-app/components/text';
import type { AccountEntity } from '@actual-app/core/types/models';

import { useSyncedPref } from '#hooks/useSyncedPref';

type AccountCurrencyBadgeProps = {
  currency: AccountEntity['currency'] | undefined;
};

/**
 * Small "EUR"-style tag shown next to an account whose currency differs from
 * the budget's default currency. Renders nothing otherwise.
 */
export function AccountCurrencyBadge({ currency }: AccountCurrencyBadgeProps) {
  const [defaultCurrencyCode] = useSyncedPref('defaultCurrencyCode');

  if (!currency || currency === (defaultCurrencyCode || '')) {
    return null;
  }

  return (
    <Text
      style={{
        marginLeft: 6,
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: 0.5,
        opacity: 0.7,
        verticalAlign: 'middle',
      }}
    >
      {currency}
    </Text>
  );
}
